import React from 'react';
import { render } from 'react-dom';
import PastContestsList from './apps/PastContestsList/PastContestsList';

// Events List Application
const pastContestsList = document.getElementById('past-contests-app');
if (pastContestsList) render(<PastContestsList {...pastContestsList.dataset} />, pastContestsList);
